/** Addon sections kept under one product. Deeper catalog levels are left out. */
export const MAX_ADDON_NESTING_DEPTH = 3;
